import React from 'react'
import { useParams } from 'react-router-dom'
import { SEOHead } from '../components/ui/SEOHead'
import { AsciiDivider } from '../components/terminal/AsciiDivider'
import { PostList } from '../components/blog/PostList'
import { Pagination } from '../components/ui/Pagination'
import { usePosts } from '../hooks/usePosts'

export const TagPage: React.FC = () => {
  const { tag } = useParams<{ tag: string }>()
  const decodedTag = tag ? decodeURIComponent(tag) : ''

  const { posts, loading, totalPages, page, setPage } = usePosts({
    tag: decodedTag,
    pageSize: 10,
  })

  return (
    <>
      <SEOHead
        title={`#${decodedTag}`}
        description={`Posts tagged with #${decodedTag} on CodeToByte`}
        url={`/tags/${decodedTag}`}
      />

      <div style={{ paddingTop: '32px' }}>
        <div
          style={{
            fontFamily: "'JetBrains Mono', 'Courier New', monospace",
            fontSize: '0.82rem',
            color: 'var(--text-secondary)',
            marginBottom: '4px',
          }}
        >
          filtering by tag:
        </div>
        <div
          style={{
            fontFamily: "'JetBrains Mono', 'Courier New', monospace",
            fontSize: '1.2rem',
            color: 'var(--accent-green)',
            marginBottom: '8px',
          }}
        >
          #{decodedTag}
        </div>

        <AsciiDivider label={`#${decodedTag.toUpperCase()}`} width={60} />

        <PostList
          posts={posts}
          loading={loading}
          emptyMessage={`No posts found with tag #${decodedTag}.`}
        />

        <Pagination
          currentPage={page}
          totalPages={totalPages}
          onPageChange={(p) => {
            setPage(p)
            window.scrollTo({ top: 0, behavior: 'smooth' })
          }}
        />
      </div>
    </>
  )
}
